"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEchoCardiography = createEchoCardiography;
const echocardiography_1 = require("../../../forms/htx/current-cardiological-state/echocardiography");
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const messages = {
    echocardiography: {
        id: "dashboard.echocardiography",
        defaultMessage: "Echokardiográfia"
    },
    ejectionFraction: {
        id: "dashboard.ejection_fraction",
        defaultMessage: "Ejekciós frakció"
    },
    edd: {
        id: "dashboard.edd",
        defaultMessage: "EDD"
    },
    swt: {
        id: "dashboard.swt",
        defaultMessage: "SWT"
    },
    pwt: {
        id: "dashboard.pwt",
        defaultMessage: "PWT"
    },
    laDiameter1: {
        id: "dashboard.la_diameter1",
        defaultMessage: "LA diameter1"
    },
    laDiameter2: {
        id: "dashboard.la_diameter2",
        defaultMessage: "LA diameter2"
    },
    raDiameter1: {
        id: "dashboard.ra_diameter1",
        defaultMessage: "RA diameter1"
    },
    raDiameter2: {
        id: "dashboard.ra_diameter2",
        defaultMessage: "RA diameter2"
    },
    aorticRootSize: {
        id: "dashboard.aortic_root_size",
        defaultMessage: "Aorta gyök"
    },
    aortaAscendensSize: {
        id: "dashboard.aorta_ascendens_size",
        defaultMessage: "Aorta ascendens"
    },
    rvSize: {
        id: "dashboard.rv_size",
        defaultMessage: "RV"
    },
    tapse: {
        id: "dashboard.tapse",
        defaultMessage: "TAPSE"
    },
    diastolicDysfunction: {
        id: "dashboard.diastolic_dysfunction",
        defaultMessage: "Diasztolés diszfunkció"
    },
    mitralInsufficiency: {
        id: "dashboard.mitral_insufficiency",
        defaultMessage: "Mitrális inszufficiencia"
    },
    aorticInsufficiency: {
        id: "dashboard.aortic_insufficiency",
        defaultMessage: "Aorta inszufficiencia"
    },
    aorticValveGradient: {
        id: "dashboard.aortic_valve_gradient",
        defaultMessage: "Aorta gradiens"
    },
    tricuspidInsufficiency: {
        id: "dashboard.tricuspid_insufficiency",
        defaultMessage: "Tricuspidális inszufficiencia"
    },
    estimatedRightVentricularPeakSystolicPressure: {
        id: "dashboard.estimated_right_ventricular_peak_systolic_pressure",
        defaultMessage: "Kalkulált kivérköri nyomás"
    },
    echoDescription: {
        id: "dashboard.echo_description",
        defaultMessage: "Megjegyzés"
    }
};
const diastolicDysfunctionMessages = {
    [echocardiography_1.DiastolicDysfunction.YES]: {
        id: "dashboard.diastolic_dysfunction.yes",
        defaultMessage: "Van"
    },
    [echocardiography_1.DiastolicDysfunction.NO]: {
        id: "dashboard.diastolic_dysfunction.no",
        defaultMessage: "Nincs"
    },
    [echocardiography_1.DiastolicDysfunction.NOT_MEASURED]: {
        id: "dashboard.diastolic_dysfunction.not_measured",
        defaultMessage: "Nem vizsgált"
    }
};
const values = [
    {
        type: "number",
        label: messages.ejectionFraction,
        query: queries_1.queries.ejectionFraction
    },
    {
        type: "number",
        label: messages.edd,
        query: queries_1.queries.edd
    },
    {
        type: "number",
        label: messages.swt,
        query: queries_1.queries.swt
    },
    {
        type: "number",
        label: messages.pwt,
        query: queries_1.queries.pwt
    },
    {
        type: "number",
        label: messages.laDiameter1,
        query: queries_1.queries.laDiameter1
    },
    {
        type: "number",
        label: messages.laDiameter2,
        query: queries_1.queries.laDiameter2
    },
    {
        type: "number",
        label: messages.raDiameter1,
        query: queries_1.queries.raDiameter1
    },
    {
        type: "number",
        label: messages.raDiameter2,
        query: queries_1.queries.raDiameter2
    },
    {
        type: "number",
        label: messages.aorticRootSize,
        query: queries_1.queries.aorticRootSize
    },
    {
        type: "number",
        label: messages.aortaAscendensSize,
        query: queries_1.queries.aortaAscendensSize
    },
    {
        type: "number",
        label: messages.rvSize,
        query: queries_1.queries.rvSize
    },
    {
        type: "number",
        label: messages.tapse,
        query: queries_1.queries.tapse
    },
    {
        type: "formatted-message",
        label: messages.diastolicDysfunction,
        query: queries_1.queries.diastolicDysfunction,
        messages: diastolicDysfunctionMessages
    },
    {
        type: "string",
        label: messages.mitralInsufficiency,
        query: queries_1.queries.mitralInsufficiency
    },
    {
        type: "string",
        label: messages.aorticInsufficiency,
        query: queries_1.queries.aorticInsufficiency
    },
    {
        type: "number",
        label: messages.aorticValveGradient,
        query: queries_1.queries.aorticValveGradient
    },
    {
        type: "string",
        label: messages.tricuspidInsufficiency,
        query: queries_1.queries.tricuspidInsufficiency
    },
    {
        type: "number",
        label: messages.estimatedRightVentricularPeakSystolicPressure,
        query: queries_1.queries.estimatedRightVentricularPeakSystolicPressure
    },
    {
        type: "string",
        label: messages.echoDescription,
        query: queries_1.queries.echoDescription
    }
];
function createEchoCardiography(intl, { events }) {
    return (0, shared_1.createMixedList)(intl, {
        events,
        label: messages.echocardiography,
        values
    });
}
